// scroll tabs

if (typeof scroll_tabs === undefined) {
  let scroll_tabs = document.querySelectorAll(".scroll-tab-link a");
} else {
  scroll_tabs = document.querySelectorAll(".scroll-tab-link a");
}

scroll_tabs.forEach((element) => {
  element.addEventListener("click", (e) => {
    e.preventDefault();
    const element = e.target;
    const targetId = element.href.split("#")[1];

    console.log("element: ", element);
    console.log("targetId: ", targetId);

    // remove active class from scroll tabs
    scroll_tabs.forEach((element) => {
      element.classList.remove("active");
    });

    // show correct tab
    element.classList.add("active");
    document.getElementById(targetId).scrollIntoView({ behavior: "smooth" });
  });
});
